import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-print-page' })
export class PrintPageComponent{
    constructor(private element: HTMLElement){
        this.element.addEventListener('click',()=> this.printPage());
    }

    private printPage(){
        window.print();
        return false;
    }
}